module.exports = __webpack_public_path__ + "static/fassa-bortolo.9c129ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/fassa-bortolo.png
// module id = 363
// module chunks = 35783957827783